angular.module('olivioConfiguratorApp')
  .controller('AssemblyCtrl', ['$scope', 'Model', 'Data', 'StepService', function ($scope, Model, Data, StepService) {
    //console.log('init AssemblyCtrl');

    $scope.OLIVIO = OLIVIO;
    $scope.model = Model.model;
    $scope.data = Data;

    // init
    // check assembly conditions
    // TODO read all available lum configuration and disable assembly options accordingly
    Data.getAssemblyOption('cpo').disabled = ($scope.model.design.lumtype === OLIVIO.LUM_MEDIO || $scope.model.design.lumtype === OLIVIO.LUM_PICCOLO);


    $scope.selectAssembly = function ($id) {
      var assembly = Data.getAssemblyOption($id);
      if (assembly) {
        if ($scope.model.assembly.id !== $id) {
          $scope.model.assembly.id = $id;
          $scope.model.assembly.individual = new Array($scope.model.design.lumcount);
          for (var i = 0; i < $scope.model.design.lumcount; i++) {
            $scope.model.assembly.individual[i] = $id;
          }
					//Model.resetIndividualHeads();
          Model.resetColor();
          StepService.configurationSteps.filter(s => s.view === 'power')[0].skipped = false;
          StepService.getStep('color').skipped = $id !== 'led';
        }
        $scope.model.assembly.done = true;
        StepService.nextStep();
      } // TODO else software configuration error
    };

  }]);
